import Box from '@mui/material/Box';

import { Typography } from '@occc/ui-design-system';

type MembershipActivityLocationProps = {
  name?: string;
  address1?: string;
  city?: string;
  state?: string;
};

/**
 * Helper to format MembershipActivityLocation fields into a legible piece
 * of text
 */
const formatAddress: (props: MembershipActivityLocationProps) => string = ({
  name,
  address1,
  city,
  state,
}) => {
  // Separate w/ a hyphen if preceded by a name
  const prefix = name ? ' - ' : '';

  // Use comma separated "city, state" if both are defined
  const cityState = city && state ? `${city}, ${state}` : `${(city || state) ?? ''}`;

  if (address1 && cityState) {
    return `${prefix}${address1}, ${cityState}`;
  }

  if (address1) {
    return `${prefix}${address1}`;
  }

  if (cityState) {
    return `${prefix}${cityState}`;
  }

  // Don't bother with the separator if the full address is blank
  return cityState;
};

export const MembershipActivityLocation = (props: MembershipActivityLocationProps) => {
  const { name } = props;

  return (
    <Box component='span'>
      <Typography component='span' variant='body2'>
        {name}
      </Typography>
      <Typography component='span' variant='body2'>
        {formatAddress(props)}
      </Typography>
    </Box>
  );
};
